export interface NFCState{
    nfcList:NFCData[] |null


}


export interface NFCData {
    nfc_id:string
    serial_number:string,
    bin_full_name:string,
    create_date:string,
    update_date:string
}


export const nfcState:NFCState={
    nfcList:null
}